import { useState, useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import { actions } from '../../../context';
import BtxSwitch from '../../Forms/BtxSwitch';
import Split from '../../Shared/Split';

const NewPims = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const { isOpen, refresh, toggle } = props;
    const [supportsConnectivity, setSupportsConnectivity] = useState(false);
    const [apps, setApps] = useState([]);
    const [selectedApp, setSelectedApp] = useState('')

    const cancel = () => {
        setSupportsConnectivity(false);
        toggle();
    };

    const toggleConnectivity = () =>
        setSupportsConnectivity(!supportsConnectivity);

    const submit = async (vals) => {
        const payload = { ...vals, supportsConnectivity: supportsConnectivity, appId: selectedApp };
        dispatch(actions.pims.saveNewPims(payload))
            .then((res) => history.push('/admin/pims/' + res))
            .then(() => refresh())
            .finally(() => cancel());
    };

    useEffect(() => {
        dispatch(actions.apps.fetchApps()).then((res) => {
            setApps(res);
            setSelectedApp(res[0].id);
        })
    }, []);

    return (
        <>
            <Modal
                className="text-light"
                isOpen={isOpen}
                centered={true}
                toggle={cancel}>
                <Form
                    onSubmit={submit}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <ModalHeader>Create PIMS</ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col>
                                        <p>PIMS Name</p>
                                        <Field
                                            name="name"
                                            label="PIMS Name"
                                            className="w-100 p-2 rounded"
                                            required
                                            component="input"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="w-100 text-center">
                                        <Split>
                                            <p className="text-nowrap pt-2">
                                                Supports connectivity?
                                            </p>
                                            &emsp;
                                            <BtxSwitch
                                                value={supportsConnectivity}
                                                onChange={toggleConnectivity}
                                            />
                                        </Split>
                                    </Col>
                                </Row>
                                <Row> 
                                    <Col>
                                        <Split>
                                            <p>App:</p>
                                            <select
                                                id="appid-select"
                                                className="rounded p-1"
                                                defaultValue={selectedApp}
                                                value={selectedApp}
                                                onChange={(e) => setSelectedApp(e.target.value)}
                                            >
                                                {apps?.map((a, x) => (
                                                    <option key={x} value={a.id}>
                                                        {a.name}
                                                    </option>
                                                ))}
                                             </select>
                                        </Split>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="danger"
                                    onClick={() =>
                                        pristine ? cancel() : form.reset()
                                    }>
                                    {pristine ? 'Cancel' : 'Clear'}
                                </Button>
                                <Button
                                    color="success"
                                    disabled={pristine || submitting}
                                    type="submit">
                                    Create
                                </Button>
                            </ModalFooter>
                        </form>
                    )}
                />
            </Modal>
        </>
    );
};

export default NewPims;
